import React, { useEffect, useState } from 'react';

// icons
import { GoPerson } from "react-icons/go";

// styling
import * as TaskColors from "../utils/colors"

const GroupedPassengerIcon = ({ groupedPassengers, flightType, job }) => {

    const [type, setType] = useState('Boarding Task')

    useEffect(() => {
        // check if boarding task
        if (job?.combinedBooking) {
            if (job?.passengers?.length > 1) {
                setType(`${job?.passengers?.length} Boardings`)
            }
            else {
                setType('1 Boarding')
            }
        }

        // check if grouped task
        if (job?.groupedBooking || job?.buggyTask) {
            if (job?.passengers?.length > 1) {
                setType(job?.passengers?.length + ' Grouped Pax')
            }
            else {
                setType('Grouped PAX')
            }
        }

        // check if ramp booking
        if (job?.combinedRampBooking) {
            if (job?.passengers?.length > 1) {
                // setType('Ramp Task ' + job?.passengers?.length + ' Pax')
                setType(`${job?.passengers?.length} Ramp`)
            }
            else {
                setType('1 Ramp')
            }
        }

        // check if flight task
        if (job?.flightTask) {
            if (job?.passengers?.length > 1) {
                setType('Flight Task (' + job?.passengers?.length + ' Pax)')
            }
            else {
                setType('Flight Pax')
            }
        }


    }, [job]);

    return (
        <p style={{ margin: "0px 0", fontSize: 10, fontWeight: "500" }}>
            {type}
        </p>
    )
};

export default GroupedPassengerIcon;
